import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "../button";
import { FaCode, FaFacebook, FaTwitter, FaLinkedin } from "react-icons/fa";
import { RiMenu3Fill } from "react-icons/ri";
import { FiChevronDown } from "react-icons/fi"
import { AiOutlineClose } from "react-icons/ai";
import "./style.css";
import { logo } from "../../assets";
const NavBar = () => {
  const [click, setClick] = useState(false);
  const [dropdown, setDropdown ] = useState(false)
  const [activeLink, setActiveLink] = useState('')
   const handleActive = (id) => {
    if(id === activeLink) {
      // alert('')
      setActiveLink('')
    }
     else{
      // alert(id)
      setActiveLink(id)
     }
   }
  const handleClick = () => setClick(!click);
  const Close = () => setClick(false);

  return (
    <div>
      <Link to="/" className="top-logo">
            <img src={logo} /> 
            <span className="logo-text">National Virtual Library of Nigeria </span>
      </Link>
      <div className={click ? "main-container" : ""} onClick={() => Close()} />
      <nav className="navbar" onClick={(e) => e.stopPropagation()}>
        <div className="nav-container">
          <Link to="/" className="nav-logo">
            <img src={logo} /> 
          </Link>
          <ul className={click ? "nav-menu active" : "nav-menu"}>
            <li className="nav-item">
              <Link
                to="/"
                // activeClassName="active"
                className="nav-links"
                onClick={click ? handleClick : null}
              >
                Home
              </Link>
            </li>
            <li className="nav-item nav_with_icon">
              <a
                
                // href="https://issnisbn.nlndata.com.ng/"
                // activeClassName="active"
                // target={"_blank"}
                className={activeLink === 'Services'?"nav-links active":'nav-links'}
                
                onClick={() => handleActive('Services') }
              >
                Services 

                <ul className="nav-list-drop">
                  <li> <a href="https://webindex.nlndata.com.ng/">Indexing Services</a> </li>
                  <li> <a href="https://www.nln.gov.ng/Home/DepartmentDetails/2">Public Services</a>  </li>
                  <li> <a href="#">Subpoena</a> </li>
                  <li> <a href="https://www.nln.gov.ng/Home/DepartmentDetails/7" target={'_blank'}>E-Library</a> </li>
                  
                
              </ul>
              
                
              </a>
              <FiChevronDown color="#fff" cursor='pointer' />
              
              
            </li>
            
            <li className="nav-item nav_with_icon">
              <a              
                // activeClassName="active"
                className={activeLink === 'Collection'?"nav-links active":'nav-links'}
                onClick={() => handleActive('Collection') }
              >
                Collections

                <ul className="nav-list-drop">
                  <li> <Link to="/nigeriana">Nigeriana</Link> </li>
                  <li> <a href="http://repository.nln.gov.ng/" target={'_blank'}>National Repository</a> </li>
                  <li 
                    className="e-resources"> 
                    <a href="#" 
                    // className="e-resources "
                    className={activeLink === 'E-resources' ? "nav-links active-sub":'nav-links'}
                    onClick={() => handleActive('E-resources') }>E-resources <FiChevronDown color="#000" />
                      <ul className="deep-drop">
                        <li> <a href="https://www.nln.gov.ng/Home/DepartmentDetails/7" target={'_blank'}>E-library</a> </li>
                        <li> <a href="#">Bold Scholar</a> </li>
                        <li> <Link to="/open-access-resources">Open Access Publications</Link> </li>
                        <li> <Link to="https://virtual.nlndata.com.ng/" target={'_blank'}>Subscribe Database</Link>  </li>
                      </ul>
                  </a> 
                   
                  </li>
                  <li> <a href="https://nigerbiblios.nlndata.com.ng/" target={'_blank'}>Nigerbiblios</a> </li>
                  <li> <a href="https://www.nln.gov.ng/Home/Nbn" target={'_blank'}>Nigerian Biography</a> </li>
                  <li> <Link to="/nigerian-newspapers">Nigerian Newspapers</Link> </li>
                
              </ul>

                
              </a>
              <FiChevronDown color="#fff" />
              
            </li>
            
            <li className="nav-item nav_with_icon">
              <Link
                // exact
                to="#"
                // target={'_blank'}
                // rel="noreferrer"
                // activeClassName="active"
                // className="nav-links"
                // onClick={click ? handleClick : null}
                className={activeLink === 'Operations' ? "nav-links active" :'nav-links'}
                onClick={() => handleActive('Operations') }
                
              >
                Operations 

                <ul className="nav-list-drop">
                  <li> <a href="https://www.nln.gov.ng/Home/DepartmentDetails/3" target={'_blank'}>CDTS</a> </li>
                  <li> <a href="https://www.nln.gov.ng/Home/DepartmentDetails/5" target={'_blank'}>Legal Deposits</a> </li>
                  <li> <a href="https://www.nln.gov.ng/Home/DepartmentDetails/6" target={'_blank'}>International Standard</a> </li>
                  <li> <a href="https://www.nln.gov.ng/Home/DepartmentDetails/4" target={'_blank'}>Planning, Research & Statistics </a> </li>
                  <li> <a href="https://www.nln.gov.ng/Home/DepartmentDetails/7" target={'_blank'}>Digitization</a> </li>
                    
              </ul>

              </Link>
              <FiChevronDown color="#fff" />
              
            </li>


            

          <li className="nav-item nav_with_icon">
              <a
                href="#"
                // activeClassName="active"
                // className="nav-links"
                // onClick={click ? handleClick : null}

                className={activeLink === 'Catalog' ? "nav-links active" :'nav-links'}
                onClick={() => handleActive('Catalog') }
                
              >
                Catalog

                <ul className="nav-list-drop">
                  <li> <a href="http://opac.nln.gov.ng/">OPAC</a> </li>
                  <li> <a href="https://webindex.nlndata.com.ng/">Indexes</a> </li>
                  {/* <li> <a href="http://repository.nln.gov.ng/" target={'_blank'} >National Repository</a> </li> */}
                  
              </ul>

                
              </a>
              <FiChevronDown color="#fff" />
              
            </li>
            
            
              <Link
                // exact
                to="/faqs"
                // activeClassName="active"
                className="nav-links nav-item"
                onClick={click ? handleClick : null}
              >
                FAQs
              </Link>

              
            <ul className="auth_container">
               <li className="sign-up">
                  <Link 
                  to='/sign-up'>
                  Sign Up</Link> 
                </li> 

               <li className="log-in" >
                  <Link 
                  to='/login'>
                  Login</Link> 
                </li> 
              
            </ul>

            
          </ul>

          

          <div className="nav-icon" onClick={handleClick}>
            {click ? (
              <i className="fa fa-times">
                <AiOutlineClose size={"25px"} />
              </i>
            ) : (
              <i className="fa fa-bars">
                {" "}
                <RiMenu3Fill size={"25px"} />
              </i>
            )}
          </div>
        </div>
      </nav>
    </div>
  );
};
export { NavBar };
